import React from 'react';
import SbEditable from 'storyblok-react';
import DynamicComponent from '~/components/DynamicComponent';
import styled from 'styled-components';
import media from '~/utils/media';

const ImageContainer = styled.div`
  flex: 1 1 100%;

  ${media.greaterThan('md')`
    flex: 0 4 50%;
  `}
`;

const Hero = ({ blok }) => {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <section className="my-20 md:my-24">
        {/* Two columns */}
        <div className="container">
          <div className="flex flex-wrap -ml-12 md:flex-nowrap">
            {/* left */}
            <div style={{ flex: '1 1 600px' }} className="flex items-center justify-center pl-12">
              {/* text card */}
              <DynamicComponent blok={blok.textCard[0]} />
            </div>

            {/* Right */}
            <ImageContainer className="flex items-center justify-center w-full pl-12 md:w-auto">
              <div className="flex-auto w-full">
                <div className="max-w-[482px] w-full mx-auto">
                  <DynamicComponent blok={blok.asset[0]} />
                </div>
              </div>
            </ImageContainer>
          </div>
        </div>
      </section>
    </SbEditable>
  );
};

export default Hero;
